import { Box, CircularProgress, SxProps } from '@mui/material';
import { getColor } from '../../assets/theme';
import { CSSProperties } from 'react';

/**
 * LoadingComponent - A customizable loading overlay component.
 *
 * This component creates a full-screen overlay with a centered loading spinner.
 * It can be customized with additional styles and the loading spinner can be hidden.
 *
 * @param {Object} props - The component props.
 * @param {CSSProperties | SxProps} [props.wrapperStyle={}] - Additional styles to apply to the wrapper Box.
 * @param {boolean} [props.hideLoading=false] - If true, the loading spinner will be hidden.
 *
 * @returns {JSX.Element} The rendered LoadingComponent.
 */
const LoadingComponent = ({
  wrapperStyle = {},
  hideLoading = false,
}: {
  wrapperStyle?: CSSProperties | SxProps;
  hideLoading?: boolean;
}) => {
  const { bgColor } = getColor();
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        zIndex: 9999,
        opacity: 0.5,
        bgcolor: bgColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '4px',
        width: '100%',
        height: '100%',
        ...wrapperStyle,
      }}
    >
      {!hideLoading && <CircularProgress />}
    </Box>
  );
};

export default LoadingComponent;
